<div [class]="classes">{{ label }}</div>
